import { message } from 'antd';
import dayjs from 'dayjs';
import * as airwayBillService from '../../services/airwayBillService';

export const useAirwayBillForm = (form, refetchAirwayBills) => {
  const formatFormData = (values) => {
    console.log('Form values before formatting:', values);
    const formattedData = {
      ...values,
      // Convert numeric fields to numbers and handle percentage
      bill_count: Number(values.bill_count) || 0,
      bill_weight: Number(values.bill_weight) || 0,
      package_count: Number(values.package_count) || 0,
      under_packed: Number(values.under_packed) || 0,
      taxed_package_count: Number(values.taxed_package_count) || 0,
      courier_fee: Number(values.courier_fee) || 0,
      average_tax: Number(values.average_tax) || 0,
      total_tax: Number(values.total_tax?.toString().replace?.('%', '')) || 0,
      additional_tax: Number(values.additional_tax) || 0,
      // Format date fields
      departure_date: values.departure_date ? values.departure_date.format('YYYY-MM-DD') : null,
      arrival_date: values.arrival_date ? values.arrival_date.format('YYYY-MM-DD') : null,
      document_send_time: values.document_send_time ? values.document_send_time.format('YYYY-MM-DD') : null,
      airport_pickup_time: values.airport_pickup_time ? values.airport_pickup_time.format('YYYY-MM-DD') : null,
      document_review_time: values.document_review_time ? values.document_review_time.format('YYYY-MM-DD') : null,
      processing_time: values.processing_time ? values.processing_time.format('YYYY-MM-DD') : null,
      customs_clearance_time: values.customs_clearance_time ? values.customs_clearance_time.format('YYYY-MM-DD') : null,
      courier_pickup_time: values.courier_pickup_time ? values.courier_pickup_time.format('YYYY-MM-DD') : null
    };
    console.log('Form data after formatting:', formattedData);
    return formattedData;
  };

  const setFormValues = (record) => {
    // Get customer ID from either customer_details or direct customer field
    const customerId = record.customer_details?.id || record.customer;

    form.setFieldsValue({
      ...record,
      customer: customerId,
      batch_ids: record.batches?.map(batch => batch.id),
      departure_date: record.departure_date ? dayjs(record.departure_date) : null,
      arrival_date: record.arrival_date ? dayjs(record.arrival_date) : null,
      document_send_time: record.document_send_time ? dayjs(record.document_send_time) : null,
      airport_pickup_time: record.airport_pickup_time ? dayjs(record.airport_pickup_time) : null,
      document_review_time: record.document_review_time ? dayjs(record.document_review_time) : null,
      processing_time: record.processing_time ? dayjs(record.processing_time) : null,
      customs_clearance_time: record.customs_clearance_time ? dayjs(record.customs_clearance_time) : null,
      courier_pickup_time: record.courier_pickup_time ? dayjs(record.courier_pickup_time) : null,
    });
  };

  const handleSave = async (isViewingDetails, selectedAirwayBill, editingBill, onSuccess) => {
    try {
      const values = await form.validateFields();
      const formData = formatFormData(values);

      if (isViewingDetails) {
        await airwayBillService.updateAirwayBill(selectedAirwayBill.id, formData);
        if (values.batch_ids?.length > 0) {
          await airwayBillService.assignBatches(selectedAirwayBill.id, values.batch_ids);
        }
        message.success('空运单更新成功');
      } else {
        if (editingBill) {
          await airwayBillService.updateAirwayBill(editingBill.id, formData);
          message.success('空运单更新成功');
        } else {
          const response = await airwayBillService.createAirwayBill(formData);
          if (values.batch_ids?.length > 0) {
            await airwayBillService.assignBatches(response.id, values.batch_ids);
          }
          message.success('空运单创建成功');
        }
      }
      refetchAirwayBills();
      onSuccess?.();
    } catch (error) {
      console.error('Error handling form submit:', error);
      message.error('操作失败');
    }
  };

  return {
    setFormValues,
    handleSave
  };
};
